import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const IndustrialSiteName = () => {
	const {
		libertyMutualResult: {
			informations: { company_name }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Industrial site')}:</Topic>
			<Value>{company_name}</Value>
		</Col>
	);
};
